import isPresent from '../../Utils/Present';

type Props = {
  propertyIndex: number,
  propertyGroupIndex: number,
  record: any
};

const DisplayPropertyValue = (props: Props) => (
  isPresent(
    props.record &&
    props.record.property_groups &&
    props.record.property_groups[props.propertyGroupIndex] &&
    props.record.property_groups[props.propertyGroupIndex].properties &&
    props.record.property_groups[props.propertyGroupIndex].properties[props.propertyIndex]
  )
);

export default DisplayPropertyValue;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/DisplayPropertyValue.tsx